import { StyleSheet, Platform } from 'react-native';
import type { EdgeInsets } from 'react-native-safe-area-context';
import { tutorialStyles } from '../styles/tutorial.styles';

/**
 * Safe-area-dependent tutorial styles (no inline style objects in components).
 */
const WEB_SAFE_TOP_SKIP = 'calc(8px + env(safe-area-inset-top, 0px))' as never;
const WEB_SAFE_TOP_CONTENT = 'calc(4px + env(safe-area-inset-top, 0px))' as never;
const WEB_SAFE_BOTTOM_ACTIONS = 'calc(16px + env(safe-area-inset-bottom, 0px))' as never;
const WEB_SAFE_PAD_LEFT = 'calc(20px + env(safe-area-inset-left, 0px))' as never;
const WEB_SAFE_PAD_RIGHT = 'calc(20px + env(safe-area-inset-right, 0px))' as never;

export const getTutorialDynamicStyles = (insets: EdgeInsets) =>
  StyleSheet.create({
    /** Root slide; on web adds notch / home-indicator horizontal insets via CSS env(). */
    slideOuter: {
      ...tutorialStyles.slide,
      ...(Platform.OS === 'web'
        ? {
            paddingLeft: WEB_SAFE_PAD_LEFT,
            paddingRight: WEB_SAFE_PAD_RIGHT,
          }
        : {}),
    },
    skipButtonAbsolute: {
      ...tutorialStyles.skipButtonAbsolute,
      ...(Platform.OS === 'web'
        ? { top: WEB_SAFE_TOP_SKIP }
        : { top: insets.top + 8 }),
    },
    slideContent: {
      ...tutorialStyles.slideContent,
      ...(Platform.OS === 'web'
        ? { paddingTop: WEB_SAFE_TOP_CONTENT }
        : { paddingTop: insets.top + 4 }),
    },
    bottomActions: {
      ...tutorialStyles.bottomActions,
      ...(Platform.OS === 'web'
        ? { paddingBottom: WEB_SAFE_BOTTOM_ACTIONS }
        : { paddingBottom: Math.max(insets.bottom, Platform.OS === 'ios' ? 12 : 16) }),
    },
  });
